import React from "react";
import { useState } from "react";
import "./styles.css"

const Header = () => {

    window.onscroll = function() {myFunction()};
      
    function myFunction() {
        var header = document.getElementById("mainHeader");
        var sticky = header.offsetTop;
        if (window.scrollY > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

    const [isOpen, setIsOpen] = useState(false);


  const toggleOpen = () => {
    setIsOpen(!isOpen);

    const spineWidth = document.querySelector('.spine');
    spineWidth.classList.toggle('isOpen');
  };

    return (
        <>
            <header id='mainHeader'>
                <button onClick={toggleOpen}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} preserveAspectRatio='none' viewBox="0 0 448 512"><path d="M0 96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"/></svg>
                </button>
            </header>
        </>
    );
}

export default Header;